module.exports = __webpack_public_path__ + "img/V-63-ER-1200-B.16eb724f.png";